import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLanguage = languages.find((l) => l.code === i18n.language) || languages[0];

  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
      title={`Switch to ${i18n.language === 'de' ? 'English' : 'Deutsch'}`}
    >
      <Globe className="w-4 h-4" />
      <span className="hidden sm:inline">{currentLanguage.flag} {currentLanguage.label}</span>
      <span className="sm:hidden">{currentLanguage.flag}</span>
    </button>
  );
}
